<template>
  <section class="manual-video-section">
    <div class="manual-video">
      <div class="manual-video__border manual-video__border_top"></div>
      <div class="manual-video__border manual-video__border_right"></div>
      <div class="manual-video__border manual-video__border_bottom"></div>
      <div class="manual-video__border manual-video__border_left"></div>
      <div class="manual-video__circle manual-video__circle_top-left"></div>
      <div class="manual-video__circle manual-video__circle_top-right"></div>
      <div class="manual-video__circle manual-video__circle_bottom-left"></div>
      <div class="manual-video__circle manual-video__circle_bottom-right"></div>
      <iframe
        class="manual-video__video"
        src="//vk.com/video_ext.php?oid=-174875268&id=456239099&hash=d8170f642b946424&hd=2"
        width="100%"
        height="400"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </section>
</template>

<script>
export default {
  name: "Manual-video"
};
</script>

<style lang="scss">
.manual-video-section {
  background: url("~@/assets/img/manual/bg-space.png") 50% 50% no-repeat;
  height: 693px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: -100px;

  @include breakpoint("md-and-down") {
    height: auto;
    padding: 0 0 25px;
    background-size: 100% 100%;
    margin-bottom: 0;
  }

  @include breakpoint("sm-and-down") {
    background-size: auto 95%;
  }
}

.manual-video {
  width: 740px;
  height: 430px;
  max-width: 90%;
  padding: 15px;
  position: relative;
  margin: 0 auto;

  &__video {
    position: relative;
    z-index: 1;
    border-radius: 6px;
  }

  &__border {
    position: absolute;
    background-color: #fbc33e;

    &_top,
    &_bottom {
      height: 3px;
      left: 30px;
      right: 30px;
    }

    &_left,
    &_right {
      width: 3px;
      top: 30px;
      bottom: 29px;
    }

    &_left {
      left: 0;
    }
    &_right {
      right: 0;
    }
    &_top {
      top: 0;
    }
    &_bottom {
      bottom: 0;
    }
  }

  &__circle {
    position: absolute;
    width: 138px;
    height: 138px;
    background: url("~@/assets/img/manual/circle.png") 50% 50% no-repeat;
    &_top-left {
      top: -64px;
      left: -64px;
    }
    &_top-right {
      top: -64px;
      right: -64px;
    }
    &_bottom-left {
      bottom: -64px;
      left: -64px;
    }
    &_bottom-right {
      bottom: -64px;
      right: -64px;
    }
  }
}
</style>
